import type { MediaState } from './types'

export const selectMedia = (state: { media: MediaState }) => state.media
export const selectMediaErrors = (state: { media: MediaState }) => state.media.errors
